import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconMessage = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z' />
    </g>
  </SDIcon>
)

export default IconMessage
